import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1280.000000 853.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >


<path d="M6720 6832 c-118 -25 -220 -59 -220 -73 0 -5 -6 -9 -14 -9 -22 0 -91
-43 -77 -48 7 -2 26 5 42 17 16 12 29 17 29 12 0 -5 -13 -19 -30 -31 -36 -26
-36 -28 -6 -62 29 -34 35 -34 104 -2 89 42 229 67 347 60 194 -9 331 -66 509
-210 l36 -28 55 33 c30 18 55 36 55 40 0 30 -141 144 -250 202 -181 96 -409
135 -580 99z m-195 -102 c-3 -5 -13 -10 -21 -10 -8 0 -12 5 -9 10 3 6 13 10
21 10 8 0 12 -4 9 -10z m-61 -66 c9 -24 7 -28 -9 -14 -17 14 -20 30 -6 30 5 0
12 -7 15 -16z m63 -20 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M6727 6570 c-93 -24 -171 -60 -175 -82 -2 -9 10 -31 26 -50 l30 -33
64 24 c79 29 231 39 309 21 71 -17 160 -62 210 -107 44 -40 53 -39 115 13 l29
24 -56 53 c-139 129 -364 185 -552 137z"/>
<path d="M6835 6341 c-22 -10 -47 -27 -57 -37 -38 -44 -39 -139 0 -185 26 -32
87 -59 132 -59 50 0 113 38 136 82 26 50 15 121 -27 164 -52 54 -116 66 -184
35z"/>
<path d="M6128 6262 l-28 -3 -1 -492 c-1 -271 -3 -525 -5 -564 -3 -65 -1 -73
15 -73 33 0 171 53 366 141 17 7 46 23 66 35 l36 22 -2 124 c-1 68 -3 279 -4
471 l-1 347 -207 -2 c-115 -2 -220 -4 -235 -6z m10 -38 c14 -15 14 -16 -3 -13
-10 2 -20 10 -23 17 -5 17 6 15 26 -4z"/>
<path d="M6647 5953 c-9 -8 -9 -593 0 -593 26 0 295 174 420 272 l63 50 0 139
0 139 -238 0 c-131 0 -242 -3 -245 -7z"/>
<path d="M7691 5814 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5885 5780 c-44 -5 -133 -11 -197 -15 l-118 -7 0 -374 0 -374 28 0
c38 1 167 25 305 56 l117 28 -2 345 -3 346 -25 1 c-14 1 -61 -2 -105 -6z"/>
<path d="M7620 5690 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7546 5605 c-16 -12 -17 -15 -4 -15 9 0 18 7 22 15 7 18 6 18 -18 0z"/>
<path d="M7444 5538 c1 -20 4 -24 17 -18 23 13 44 40 30 40 -6 0 -11 -4 -11
-10 0 -14 -27 -12 -33 3 -2 6 -4 0 -3 -15z"/>
<path d="M7380 5496 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z"/>
<path d="M7312 5433 c-15 -16 -21 -23 -13 -16 9 6 30 19 46 27 19 10 24 16 13
16 -10 0 -30 -12 -46 -27z"/>
<path d="M7234 5390 c-12 -5 -25 -14 -29 -20 -4 -7 7 -4 24 4 17 9 31 19 31
21 0 6 1 6 -26 -5z"/>
<path d="M5163 5342 l-43 -3 0 -127 c0 -70 -3 -143 -5 -162 -10 -61 -7 -62
193 -63 99 0 185 3 191 7 13 8 16 323 3 343 -7 11 -215 14 -339 5z"/>
<path d="M6796 5331 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z"/>
<path d="M6715 5280 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M7000 5270 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"/>
<path d="M6950 5240 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M7160 5227 c-62 -27 -166 -73 -365 -157 -55 -24 -163 -65 -240 -92
-77 -27 -165 -58 -195 -69 -123 -45 -396 -117 -617 -164 -144 -31 -173 -34
-256 -28 -124 8 -148 2 -145 -37 2 -29 4 -30 53 -31 27 -1 58 -1 68 0 9 1 17
-1 18 -6 0 -4 3 -17 5 -28 2 -11 5 -44 5 -72 l2 -53 48 0 c42 0 49 3 49 19 0
15 -8 21 -32 23 l-33 3 -2 73 -3 72 80 0 79 0 -5 -42 c-3 -23 -3 -52 1 -65 5
-20 11 -23 55 -23 l50 0 0 -54 c0 -77 -5 -86 -51 -86 l-39 0 0 -59 c0 -33 3
-62 8 -64 4 -3 28 -3 55 0 44 5 47 8 47 34 0 24 5 29 34 34 50 10 192 2 186
-10 -2 -5 -11 -9 -20 -7 -13 2 -13 1 1 -10 23 -19 32 -138 10 -138 -14 0 -14
-1 -1 -10 13 -9 13 -11 0 -20 -43 -28 452 2 685 41 172 29 393 83 405 100 5 7
206 223 228 245 9 9 12 84 12 302 l0 290 -64 46 c-78 55 -84 58 -116 43z m98
-165 c14 -39 33 -448 22 -478 -13 -32 -24 -36 -245 -89 -104 -25 -233 -57
-285 -70 -52 -12 -116 -26 -141 -30 l-46 -7 -6 34 c-3 18 -11 121 -18 228 -12
191 -12 196 9 241 20 44 24 47 84 63 69 18 541 132 573 138 30 6 42 -1 53 -30z
m-828 -201 c0 -16 -6 -31 -15 -35 -11 -4 -15 2 -15 23 0 15 3 31 7 34 14 15
23 6 23 -22z m0 -112 c0 -19 -4 -29 -12 -27 -16 6 -17 58 -1 58 8 0 13 -12 13
-31z m0 -95 c0 -21 -4 -33 -10 -29 -17 10 -11 65 7 65 2 0 3 -16 3 -36z m-422
-122 l3 -93 -88 3 -88 3 -7 60 c-4 33 -5 75 -2 93 l5 33 87 -3 87 -3 3 -93z
m432 28 c0 -16 -4 -30 -10 -30 -5 0 -10 14 -10 30 0 17 5 30 10 30 6 0 10 -13
10 -30z m10 -106 c0 -45 -22 -41 -27 4 -3 24 0 32 11 32 12 0 16 -10 16 -36z
m2 -99 c-2 -14 -8 -25 -13 -25 -10 0 -12 43 -3 53 13 12 21 -3 16 -28z m-142
-91 l0 -74 -85 0 -85 0 0 73 c0 41 2 76 4 78 2 2 41 3 85 1 l81 -4 0 -74z"/>
<path d="M5982 4465 c-11 -12 -10 -15 3 -15 8 0 15 7 15 15 0 18 -2 18 -18 0z"/>
<path d="M6850 5200 c-12 -8 -11 -10 7 -10 12 0 25 5 28 10 8 13 -15 13 -35 0z"/>
<path d="M6734 5144 c-18 -14 -18 -14 6 -3 31 14 36 19 24 19 -6 0 -19 -7 -30
-16z"/>
<path d="M6310 5110 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M6640 5109 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6200 5070 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M6491 5059 c-24 -10 -52 -19 -63 -19 -10 0 -16 -4 -13 -10 3 -6 28
-1 63 12 62 22 68 26 61 32 -2 3 -24 -4 -48 -15z"/>
<path d="M5865 4980 c-13 -5 -14 -9 -5 -9 8 0 24 4 35 9 13 5 14 9 5 9 -8 0
-24 -4 -35 -9z"/>
<path d="M6175 4963 c-11 -2 -30 -6 -42 -9 -13 -2 -23 -8 -23 -13 0 -8 34 0
85 20 21 8 13 9 -20 2z"/>
<path d="M5738 4953 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5598 4933 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M5934 4895 c-18 -14 -17 -14 11 -5 17 5 39 11 50 13 13 3 9 5 -11 6
-16 0 -39 -6 -50 -14z"/>
<path d="M5828 4873 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5660 4840 c-17 -6 -9 -7 25 -3 28 3 52 7 54 9 8 7 -54 2 -79 -6z"/>
<path d="M4430 4797 l0 -43 45 -2 c39 -1 45 1 49 21 11 53 0 64 -71 65 -20 1
-23 -4 -23 -41z"/>
<path d="M5565 4830 c-18 -8 -17 -9 8 -9 15 -1 27 4 27 9 0 12 -8 12 -35 0z"/>
<path d="M5508 4813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5368 4793 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5098 4783 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4927 4722 l-28 -3 3 -72 3 -72 80 0 80 0 3 72 3 71 -58 4 c-32 1
-71 2 -86 0z"/>
<path d="M4560 4550 l0 -80 91 0 90 0 -2 80 -2 80 -88 0 -89 0 0 -80z"/>
<path d="M5332 4422 c-30 -29 -38 -32 -97 -32 -61 0 -80 -9 -54 -26 16 -9 172
-5 182 5 5 5 7 26 5 47 l-3 38 -33 -32z"/>
<path d="M4817 4424 c-4 -4 -7 -43 -7 -86 l0 -78 85 0 86 0 -3 83 -3 82 -75 3
c-42 1 -79 0 -83 -4z"/>
<path d="M6001 4274 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3945 3888 c-9 -62 -25 -165 -35 -228 -10 -63 -21 -140 -25 -170 -4
-30 -18 -125 -31 -210 -13 -85 -24 -165 -24 -178 l0 -22 267 2 267 3 12 65 c7
36 13 71 13 78 1 9 -38 12 -163 12 -91 0 -167 3 -169 8 -4 7 81 623 99 725 l6
27 -100 0 -99 0 -18 -112z"/>
<path d="M4710 3713 c-56 -6 -179 -34 -184 -41 -2 -4 1 -32 7 -63 l10 -56 56
15 c81 22 170 21 204 -1 24 -16 28 -24 25 -60 l-3 -42 -84 -7 c-193 -16 -296
-79 -325 -201 -14 -57 25 -140 79 -170 65 -35 175 -25 243 23 23 17 44 30 47
30 2 0 5 -12 7 -27 3 -28 4 -28 84 -31 l81 -3 7 73 c3 40 18 144 33 231 22
133 24 164 14 197 -15 52 -53 94 -98 113 -41 16 -147 27 -203 20z m92 -392
c-2 -19 -8 -45 -13 -58 -19 -52 -127 -83 -163 -47 -22 22 -20 77 3 98 29 26
91 46 136 43 39 -2 40 -3 37 -36z"/>
<path d="M5340 3706 c-177 -38 -291 -201 -278 -397 5 -89 38 -153 97 -191 42
-27 52 -29 117 -26 52 2 83 10 121 30 l51 26 -5 -36 c-13 -91 -61 -142 -140
-149 -42 -4 -160 14 -204 31 -12 5 -19 -7 -33 -54 -10 -33 -16 -66 -13 -73 15
-39 256 -64 358 -37 96 25 175 98 200 183 22 77 99 589 99 659 l0 31 -85 -5
c-50 -3 -112 1 -148 9 -72 15 -66 15 -137 -1z m151 -147 c13 -7 18 -17 14 -32
-2 -12 -9 -58 -15 -102 -6 -44 -14 -96 -18 -115 -10 -46 -60 -80 -116 -80 -72
1 -96 36 -96 137 0 45 7 82 19 108 21 44 65 90 96 98 26 7 92 -1 116 -14z"/>
<path d="M6668 3706 c-126 -27 -204 -111 -196 -212 6 -71 34 -106 116 -144
127 -60 132 -63 139 -88 4 -17 -1 -30 -16 -45 -18 -19 -32 -22 -89 -20 -37 0
-87 8 -111 17 -25 9 -48 13 -52 9 -15 -18 -41 -115 -32 -124 20 -20 158 -41
233 -35 174 12 263 85 262 213 -1 91 -36 128 -174 182 -68 27 -92 51 -83 81
13 40 92 52 178 26 26 -8 49 -11 51 -8 2 4 11 31 21 61 16 51 17 55 1 66 -15
11 -148 36 -179 34 -7 0 -37 -6 -69 -13z"/>
<path d="M5995 3697 c-63 -21 -97 -42 -143 -88 -103 -103 -140 -288 -81 -404
29 -56 56 -83 114 -113 42 -21 64 -25 140 -26 105 0 154 12 219 55 106 71 161
192 154 347 -3 79 -6 91 -36 134 -18 26 -54 60 -80 75 -41 25 -58 28 -147 30
-63 2 -115 -2 -140 -10z m168 -137 c48 -38 58 -129 25 -242 -36 -124 -181
-166 -223 -64 -32 76 -11 231 39 285 41 45 115 55 159 21z"/>
<path d="M8491 3314 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7582 3250 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M8301 3234 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8889 3228 c-7 -13 -19 -29 -28 -36 -14 -11 -14 -11 2 -6 16 6 55 64
43 64 -3 0 -11 -10 -17 -22z"/>
<path d="M7306 3221 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M7457 3194 c-10 -19 -13 -33 -7 -29 14 9 42 65 32 65 -5 0 -16 -16
-25 -36z"/>
<path d="M7775 3220 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8484 3199 c0 -9 5 -15 12 -12 20 7 25 -39 6 -53 -14 -10 -18 -10
-20 1 -3 12 -9 11 -37 -2 -19 -9 -32 -20 -30 -24 7 -11 -25 -20 -47 -14 -10 4
-15 11 -12 17 5 7 -2 9 -20 6 -18 -4 -30 0 -36 11 -6 11 -9 12 -10 3 0 -29 31
-42 128 -54 126 -14 264 -1 339 33 29 13 53 27 53 30 0 11 -35 6 -48 -8 -7 -7
-21 -13 -30 -13 -14 0 -14 2 -3 9 9 6 11 16 7 27 -6 15 -9 16 -16 5 -5 -9 -15
-11 -26 -7 -16 6 -16 9 -4 17 12 8 10 10 -7 6 -13 -3 -23 -2 -23 2 0 5 10 13
23 20 22 11 22 11 -3 5 -55 -15 -140 -16 -168 -2 -25 13 -28 13 -28 -3z m156
-33 c0 -19 -14 -28 -34 -20 -12 5 -13 9 -3 20 16 18 37 18 37 0z"/>
<path d="M7895 3200 c-3 -5 3 -10 14 -10 12 0 21 5 21 10 0 6 -6 10 -14 10 -8
0 -18 -4 -21 -10z"/>
<path d="M8162 3190 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M7800 3196 c0 -9 39 -13 51 -5 10 6 4 9 -18 9 -18 0 -33 -2 -33 -4z"/>
<path d="M7128 3183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7165 3180 c-4 -7 14 -9 50 -6 75 5 83 16 12 16 -31 0 -59 -5 -62
-10z"/>
<path d="M8828 3163 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7600 3156 c0 -4 9 -16 20 -28 11 -12 20 -17 20 -11 0 5 -9 18 -20
28 -11 10 -20 15 -20 11z"/>
<path d="M7394 3131 c-35 -21 -51 -41 -35 -41 6 0 11 5 11 10 0 6 5 10 11 10
6 0 22 9 36 20 33 25 18 26 -23 1z"/>
<path d="M7911 3145 c0 -5 3 -16 7 -22 6 -10 12 -10 28 3 19 15 18 15 -3 11
-12 -3 -24 0 -27 7 -2 6 -5 7 -5 1z"/>
<path d="M7975 3140 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8136 3125 c-16 -21 -27 -25 -72 -25 -29 0 -56 5 -59 10 -8 13 -25 3
-25 -16 0 -11 18 -14 90 -14 l90 0 0 35 c0 19 -1 35 -3 35 -1 0 -11 -11 -21
-25z"/>
<path d="M6996 3131 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M7152 3104 c-9 -10 -3 -14 31 -17 40 -3 39 -4 -10 -5 -41 -2 -53 1
-53 13 0 8 -7 15 -15 15 -8 0 -15 -4 -15 -10 0 -5 -12 -11 -27 -11 -22 -1 -20
-3 12 -10 78 -16 255 -8 255 12 0 4 -15 3 -32 -2 -41 -11 -38 -12 -38 5 0 28
-84 35 -108 10z"/>
<path d="M7670 3099 c0 -11 12 -18 38 -23 51 -8 112 -8 112 2 0 4 -30 7 -66 8
-45 0 -68 5 -75 15 -7 12 -9 11 -9 -2z"/>
<path d="M7860 3094 c-22 -12 -22 -14 -5 -14 24 0 51 16 39 22 -5 3 -20 -1
-34 -8z"/>
<path d="M7360 2640 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6518 2633 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5318 2595 c-3 -13 -2 -22 2 -20 11 7 20 45 10 45 -4 0 -10 -11 -12
-25z"/>
<path d="M6384 2606 c-3 -8 -4 -23 -2 -33 3 -11 6 -6 9 15 6 34 2 42 -7 18z"/>
<path d="M6701 2594 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5076 2560 c4 -19 13 -48 20 -65 l14 -30 -6 35 c-4 19 -13 49 -20 65
l-14 30 6 -35z"/>
<path d="M5161 2564 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5565 2570 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M6581 2564 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5790 2560 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7261 2554 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5006 2535 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M6786 2532 c-2 -4 -1 -14 4 -22 7 -11 9 -9 7 8 -1 24 -3 26 -11 14z"/>
<path d="M5141 2512 c-6 -12 -11 -29 -10 -39 0 -11 6 -6 15 16 16 37 12 55 -5
23z"/>
<path d="M7080 2509 c0 -8 7 -23 15 -33 11 -14 15 -16 15 -5 0 8 -7 23 -15 33
-11 14 -15 16 -15 5z"/>
<path d="M4968 2468 c-4 -24 -2 -28 16 -28 13 0 16 3 10 8 -7 4 -14 16 -16 27
-3 17 -5 15 -10 -7z"/>
<path d="M5590 2465 c0 -14 4 -25 9 -25 4 0 6 11 3 25 -2 14 -6 25 -8 25 -2 0
-4 -11 -4 -25z"/>
<path d="M6275 2470 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7252 2454 c-11 -12 -2 -14 60 -12 67 2 68 2 18 5 -30 3 -57 8 -60
12 -3 5 -11 3 -18 -5z"/>
<path d="M4750 2449 c-31 -6 -30 -6 18 -8 28 0 52 1 52 3 0 8 -37 11 -70 5z"/>
<path d="M4830 2450 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7555 2450 c-3 -5 3 -10 14 -10 12 0 21 5 21 10 0 6 -6 10 -14 10 -8
0 -18 -4 -21 -10z"/>
<path d="M8035 2450 l-50 -7 58 -1 c32 -1 57 2 57 8 0 6 -3 9 -7 8 -5 0 -30
-4 -58 -8z"/>
<path d="M7128 2443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8213 2443 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
